const user = {};

export default user;
